/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findAll5 } from '../fn/department/find-all-5';
import { FindAll5$Params } from '../fn/department/find-all-5';
import { MhDepartment } from '../models/mh-department';
import { updateDepartment } from '../fn/department/update-department';
import { UpdateDepartment$Params } from '../fn/department/update-department';

@Injectable({ providedIn: 'root' })
export class DepartmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateDepartment()` */
  static readonly UpdateDepartmentPath = '/api/departments/{id}';

  /**
   * Updates a department with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDepartment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDepartment$Response(params: UpdateDepartment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateDepartment(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a department with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDepartment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDepartment(params: UpdateDepartment$Params, context?: HttpContext): Observable<void> {
    return this.updateDepartment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `findAll5()` */
  static readonly FindAll5Path = '/api/values/departments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll5()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll5$Response(params?: FindAll5$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MhDepartment>>> {
    return findAll5(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll5$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll5(params?: FindAll5$Params, context?: HttpContext): Observable<Array<MhDepartment>> {
    return this.findAll5$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MhDepartment>>): Array<MhDepartment> => r.body)
    );
  }

}
